export default function OrderConfirmed(props){
    let total = 0;
    return (
        <div className="order-confirmed-container">
            <img src="/images/icon-order-confirmed.svg" alt="order confirmed" />
            <h1>Order Confirmed</h1>
            <p>We hope you enjoy your food!</p>
            <div className='order-confirmed-products'>
                {
                props.cart.map((product, index) => {
                    total = parseInt(total) + parseInt(product.total);
                    return <div key={index}>
                    <div className='order-confirmed-product'>
                    <img src={product.image.thumbnail} alt={product.category} />
                    <div className='order-confirmed-product-description'>
                        <h4>{product.name}</h4>
                        <div className='order-confirmed-product-description-quantity-price'>
                        <div className='product-quantity'>
                            {product.quantity}x
                        </div>
                        <div className='product-price'>
                            @ ${product.price}
                        </div>
                        </div>
                    </div>
                    <div className='order-confirmed-product-total product-total'>
                        ${product.total}
                    </div>
                    </div>
                    <hr />
                    </div>
                })
                }

                <div className='order-confirmed-total-cart'>
                <div>
                    <p>Order Total</p>
                    </div>
                    <div>
                        <h3>${total.toFixed(2)}</h3>
                    </div>
                </div>

            </div>
            <button onClick={props.startNewOrder}>Start New Order</button>
        </div>
    )
}